export function formatTransactionDate(dateString: any): string | null {
  if (!dateString) return null;
  const parts = dateString.split('.');
  if (parts.length !== 3) return null;

  const [day, month, year] = parts;

  return `${year}-${month}-${day}`;
}
